import { React, useState, useEffect } from "react";
import { useHistory, Link, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import CardProfile from "../../components/Card/CardProfile";
import Map from "../../components/Map";
import CardStatus from "../../components/Card/CardStatus";
import ValueComp from "../Footer/ValueComp";
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import PageWrapper from '../PageWrapper';
import ShowcaseContainer from './ShowcaseContainer';
import ModalCreateShowcase from "../../components/Modal/ModalCreateShowcase";
import ModalAddPost from "../../components/Modal/ModalAddPost";
import Swal from "sweetalert2";
import noDataAvailableImg from '../../common/images-new/no-data-available.png';
import {
    getShowcases,
    createShowcase,
    getAboutPost,
    addShowcasePost,
    getMyPosts,
    getStatusPost
} from "../../redux/actions/showcase";
import PublicCardProfile from "../../components/Card/PublicCardProfile";
import PublicShowcaseContainer from "./PublicShowcaseContainer";
import { serverUrl } from "../../components/Helpers/Config";
import axios from "axios";
import { staticFiles } from "../../components/Helpers/Static";
import PublicCardStatus from "../../components/Card/PublicCardStatus";
import { tokenAuthorize, removeIframe } from "../../components/Helpers/Common";
import { defaultTheme } from "../Theme";
import { ButtonCommonTopNew, ButtonCommonTopGrey, ActiveSpanColor } from '../../pages/Theme';
import { BsSortUpAlt } from "react-icons/bs";
import { BsSortDown } from "react-icons/bs";
import RichTextReadMore from "../../components/Editor/RichTextReadMore";
import bgImage from "../../common/images-new/status-bg1.png";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { FaRegCommentDots } from "react-icons/fa";
import NoProfilePhoto from "../../common/images-new/no-profile-pic.png";
import LikeComment from "../../components/LikeComment/LikeComment";
import Loader from "../../components/Button/Loader";
import { getAnalyticsModuleCardDetails } from '../../redux/actions/analyticsActions';
import Tooltip from '@mui/material/Tooltip';
import CommonLoader from "../../components/Button/Loader";
import { GET_THEME_LOADER, GET_USER_THEME } from "../../redux/actions/auth";
const SHOWCASE_ICON = staticFiles.book;
const DEFAULT_COVER = staticFiles.coverDefault;
const EDIT_LAYOUT_ICON = staticFiles.editLayout;

function getQueryParam(key) {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
}

const GuestPublicProfile = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation();
    const { userId } = useParams()
    const profileId = getQueryParam('profile_id');
    const [userData, setUserData] = useState({
        about: '',
        competencies: [],
        cover: '',
        email: '',
        name: '',
        photo: '',
        gid: '',
        programme: '',
        showcases: [],
        guid: "",
        pinnedImage: "",
        programme_category: "",
    })

    const [teachingPhil, setTeachingPhil] = useState({
        content: '',
        id: 0,
        likes: 0,
        comments: 0,
    })

    const [theme, setTheme] = useState(defaultTheme);
    const [isEmailVisible, SetEmailVisible] = useState(false);
    const analyticsCardsDetails = useSelector((state) => state.analyticsReducer.card_details || []);

    useEffect(() => {
        axios.get(serverUrl.ProfileSettings).then(res => {
            if (res.status === 200) {
                SetEmailVisible(res?.data?.results?.display_email);
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
        })
    }, []);
    const isThemeLoader = useSelector(state => state.auth.isThemeLoader);
    const userGuid = useSelector(state => state.auth?.user?.guid);
    const [sortOrder, setSortOrder] = useState('desc');
    const [selectGroup, setSelectGroup] = useState();
    const [competencyGroup, setCompetencyGroup] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [pinnedReflection, setPinnedReflection] = useState("");
    const root = document.documentElement;
    const [compentencyLoading, setcompentencyLoading] = useState(false);

    useEffect(() => {
        setcompentencyLoading(true);
        dispatch(getAnalyticsModuleCardDetails());
        let url="";
        if(userGuid){
            url=serverUrl.AnalyticsCompetencyGroups+'?user_guid='+userGuid+'&is_public_view=true'
        }
        else{
            url=serverUrl.AnalyticsCompetencyGroups
        }
        axios.get(url).then(resp => {
            if (resp.status === 200) {
                setCompetencyGroup(resp?.data?.results);
                setSelectGroup(resp?.data?.results[0]?.competency_group_id);
                setcompentencyLoading(false);
            }
        }).catch(err => {
            setcompentencyLoading(false);
            tokenAuthorize(err?.response?.status);
        });
    }, []);

    useEffect(() => {
        const selectedGroup = competencyGroup?.find(
            group => group.competency_group_id === selectGroup
        );

        if (!selectedGroup) return;
        const sortedValueTitles = [...selectedGroup.value_titles].sort((a, b) => {
            if (sortOrder === 'asc') {
                return a?.count - b?.count;
            } else {
                return b?.count - a?.count;
            }
        });
        setFilteredData(sortedValueTitles);
    }, [selectGroup, competencyGroup, sortOrder]);
    useEffect(() => {
        loadUserData(userId)
    }, [userId])
    //PROD Issue
    const [errorProfile, setErrorProfile] = useState('');
    const [loader,setloader]=useState(false);
    const loadUserData = (userCode) => {
        //localStorage.setItem('themeLoader', true);
        dispatch({ type: GET_THEME_LOADER, payload: true });
        setloader(true);
        // dispatch({ type: GET_USER_THEME, payload: "" });
        return axios.get(
            serverUrl.GuestShowcase + '/' + userCode + '?profile_id=' + profileId
        ).then(resp => {
            if (resp.status === 200) {
                const data = resp.data

                setUserData({
                    about: data.about,
                    gid: data.gid,
                    competencies: data.competencies,
                    cover: data.cover,
                    email: (data.display_email && data.display_email.length > 0) ? data.display_email : data.email,
                    name: data.fullname,
                    photo: data.photo,
                    programme: data.programme,
                    showcases: data.showcases,
                    teachingPhilosophy: data.teaching_philosophy,
                    guid: data.guid,
                    pinnedImage: data.pinned_reflection_image,
                    programme_category: data.programme_category
                })
                if (data.teaching_philosophy) {
                    setTeachingPhil({
                        content: data.teaching_philosophy.content,
                        id: data.teaching_philosophy.id,
                        likes: data.teaching_philosophy.likes,
                        is_like: data.teaching_philosophy.is_like,
                        comments: data.teaching_philosophy.comments,
                    })
                }
                if (data.theme) {
                    dispatch({ type: GET_USER_THEME, payload: data.theme });
                    let userTheme = data.theme;
                    const currentTheme = {
                        pageBackground: userTheme?.color1 ? userTheme?.color1 : '#F7F8FA',
                        blue: userTheme?.color2 ? userTheme?.color2 : '#0054A6',
                        darkBlue: userTheme?.color3 ? userTheme?.color3 : '#31658e',
                        white: userTheme?.color4 ? userTheme?.color4 : 'white',
                        black: userTheme?.color5 ? userTheme?.color5 : '#111822',
                        gray: userTheme?.color6 ? userTheme?.color6 : '#9ca3af',
                        lightGray: userTheme?.color7 ? userTheme?.color7 : '#969696',
                        deleteRed: userTheme?.color2 ? userTheme?.color2 : '#DC2626',
                        green: userTheme?.color8 ? userTheme?.color8 : '#66D692',
                        navBg: userTheme?.color3 ? userTheme?.color3 : 'white',
                        navText: userTheme?.color2 ? userTheme?.color2 : 'black',
                        liDivColor: userTheme?.color2 ? userTheme?.color2 : 'black',
                        liDivColorHover: userTheme?.color7 ? userTheme?.color7 : 'gray',
                        buttonTopColor: 'white',
                        modalInActiveBgColor: userTheme?.color4 ? userTheme?.color4 : 'white',
                        modalInActiveColor: userTheme?.color6 ? userTheme?.color6 : 'Black',
                        BorderColor: userTheme?.color6 ? userTheme?.color6 : 'gray',
                        ButtonGreenBgColor: userTheme?.color4 ? userTheme?.color4 : '#66d693',
                        ButtonGreenColor: userTheme?.color6 ? userTheme?.color6 : 'white',
                        ButtonGreenHoverColor: userTheme?.color7 ? userTheme?.color7 : '#00b050',
                        ButtonThemeGreen: userTheme?.color5 ? userTheme?.color5 : '#66d693',
                        ButtonThemeBgGreen: userTheme?.color6 ? userTheme?.color6 : 'rgba(209, 213, 219)',
                        PubishIcon: userTheme?.color8 ? userTheme?.color8 : 'black',
                        sortIcon: userTheme?.color6 ? userTheme?.color6 : '#2084D4',
                        //New Code
                        NavBarColor: userTheme?.color2 ? userTheme?.color2 : '#FFFFFF',
                        iconGreen: userTheme?.color2 ? userTheme?.color2 : '#059669',
                        iconBlue: userTheme?.color2 ? userTheme?.color2 : '#2563eb',
                        preferenceBg: userTheme?.color2 ? userTheme?.color2 : '#f9fafb',
                        preferenceText: userTheme?.color2 ? userTheme?.color2 : '#111822',
                    }
                    root.style.setProperty('--varBackgroundColor', userTheme?.color1 ? userTheme?.color1 : '#F7F8FA');
                    root.style.setProperty('--varBlueColor', userTheme?.color2 ? userTheme?.color2 : '#0054A6');
                    root.style.setProperty('--varDarkBlueColor', userTheme?.color3 ? userTheme?.color3 : '#31658e');
                    root.style.setProperty('--varCardBackgroundColor', userTheme?.color4 ? userTheme?.color4 : '#FFFFFF');
                    root.style.setProperty('--varBlackColor', userTheme?.color5 ? userTheme?.color5 : '#111822');
                    root.style.setProperty('--varGreyColor', userTheme?.color6 ? userTheme?.color6 : '#9ca3af');
                    root.style.setProperty('--varLightColor', userTheme?.color7 ? userTheme?.color7 : '#969696');
                    root.style.setProperty('--varGreenColor', userTheme?.color8 ? userTheme?.color8 : '#F7F8FA');
                    root.style.setProperty('--varDeleteRed', userTheme?.color2 ? userTheme?.color2 : '#DC2626');

                    root.style.setProperty('--varNavBarColor', userTheme?.color2 ? userTheme?.color2 : '#FFFFFF');
                    root.style.setProperty('--varNavBarActiveColor', userTheme?.color3 ? userTheme?.color3 : '#0054A6');
                    root.style.setProperty('--varNavBarInActiveColor', userTheme?.color5 ? userTheme?.color5 : '#111822');

                    root.style.setProperty('--varPirmaryIcon', userTheme?.color2 ? userTheme?.color2 : '#0054A6');
                    root.style.setProperty('--varSecondaryIcon', userTheme?.color6 ? userTheme?.color6 : '#9ca3af');

                    root.style.setProperty('--varIconGreen', userTheme?.color2 ? userTheme?.color2 : '#059669');
                    root.style.setProperty('--varIconBlue', userTheme?.color2 ? userTheme?.color2 : '#2563eb');

                    root.style.setProperty('--varPreferenceBg', userTheme?.color2 ? userTheme?.color2 : '#f9fafb');
                    root.style.setProperty('--varPreferenceText', userTheme?.color2 ? userTheme?.color2 : '#111822');
                    setTheme(currentTheme)
                } else {
                    dispatch({ type: GET_USER_THEME, payload: "" });
                    root.style.setProperty('--varBackgroundColor', '#F7F8FA');
                    root.style.setProperty('--varBlueColor', '#0054A6');
                    root.style.setProperty('--varDarkBlueColor', '#31658e');
                    root.style.setProperty('--varCardBackgroundColor', '#FFFFFF');
                    root.style.setProperty('--varBlackColor', '#111822');
                    root.style.setProperty('--varGreyColor', '#9ca3af');
                    root.style.setProperty('--varLightColor', '#969696');
                    root.style.setProperty('--varGreenColor', '#F7F8FA');
                    root.style.setProperty('--varDeleteRed', '#DC2626');

                    root.style.setProperty('--varNavBarColor', '#FFFFFF');
                    root.style.setProperty('--varNavBarActiveColor', '#0054A6');
                    root.style.setProperty('--varNavBarInActiveColor', '#111822');

                    root.style.setProperty('--varPirmaryIcon', '#0054A6');
                    root.style.setProperty('--varSecondaryIcon', '#9ca3af');

                    root.style.setProperty('--varIconGreen', '#059669');
                    root.style.setProperty('--varIconBlue', '#2563eb');
                    root.style.setProperty('--varPreferenceBg', '#f9fafb');
                    root.style.setProperty('--varPreferenceText', '#111822');
                    setTheme(defaultTheme)
                }
                //localStorage.setItem('themeLoader', false);
                dispatch({ type: GET_THEME_LOADER, payload: false });
            } else {
                //localStorage.setItem('themeLoader', false);
                dispatch({ type: GET_THEME_LOADER, payload: false });
            }
            setloader(false);
        }).catch(err => {
            //localStorage.setItem('themeLoader', false);
            dispatch({ type: GET_THEME_LOADER, payload: false });
            setloader(false);
            tokenAuthorize(err?.response?.status);
            console.log(err)
            //PROD Issue
            if (err?.response?.status == 500) {
                setErrorProfile("Invalid Learner Profile")
            }

        });
    }

    useEffect(() => {
        let data = "userTheme" + userId;
        localStorage.setItem(data, JSON.stringify(theme));
    }, [theme])

    const handleAddComment = (postId) => {

        let updatedShowcases = userData.showcases.map(scData => ({
            ...scData,
            posts: scData.posts.map(scPost => ({
                ...scPost,
                comments: (scPost.id !== postId) ?
                    scPost.comments :
                    scPost.comments + 1,
            }))
        }))

        setUserData({
            ...userData,
            showcases: updatedShowcases
        })

        if (teachingPhil.id === postId) {
            setTeachingPhil({
                ...teachingPhil,
                comments: teachingPhil.comments + 1
            })
        }
    }

    const handleLikePost = (postId, isLiked) => {
        const likeDiff = isLiked ? 1 : -1;

        let updatedShowcases = userData.showcases.map(scData => ({
            ...scData,
            posts: scData.posts.map(scPost => ({
                ...scPost,
                likes: (scPost.id !== postId) ? scPost.likes : {
                    avatars: scPost.likes.avatars,
                    is_like: likeDiff > 0 ? true : false,
                    count: scPost.likes.count + likeDiff
                }
            }))
        }))

        setUserData({
            ...userData,
            showcases: updatedShowcases
        })

        if (teachingPhil.id === postId) {
            setTeachingPhil({
                ...teachingPhil,
                is_like: likeDiff > 0 ? true : false,
                likes: teachingPhil.likes + likeDiff
            })
        }
    }
    return (<>
        {loader && <Loader loading={loader} />}
        <PageWrapper hideNav={true} isGuest={true} tempTheme={theme}>
            <div className="w-full">
                <div className="mx-auto">
                    <div className="rounded-lg overflow-hidden cardBackgroundColor pb-6">
                        {/* Banner Section */}
                        <div className="relative h-40 sm:h-52 md:h-56 lg:h-64 bg-gradient-to-r from-blue-900 via-black to-red-700 bg-cover bg-no-repeat" style={{ backgroundImage: `url(${(userData?.cover != "" && userData?.cover != null) ? userData.cover : DEFAULT_COVER})` }}>
                        </div>

                        {/* Content Wrapper */}
                        <div className={`relative px-4 ${userData?.programme_category?'':'pb-6'} ${errorProfile && "md:h-20"}`}>
                            {/* Profile Image */}
                            <div className="w-full flex justify-center md:block">
                                <div className="relative -mt-10 md:left-6 md:absolute md:transform md:-translate-y-32 z-10">
                                    <img
                                        src={userData.photo ? userData.photo : NoProfilePhoto} // Replace this with your image path
                                        alt="Profile"
                                        className={`h-56 w-56 rounded-lg object-cover ${userData?.photo ? '' : "bg-gray"} `}
                                    />
                                </div>
                            </div>

                            {/* Main Content */}
                            <div className="mt-4 md:pl-64 lg:pl-64">
                                {/* Metadata Grid */}
                                <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-2 md:gap-6 text-sm mt-6">

                                    {/* User Info */}
                                    <div className="text-center sm:text-left">
                                        <h2 className="text-xl blackColor font-bold">{userData.name}</h2>
                                        {isEmailVisible && <p className="text-base lightColor font-normal break-words">{userData?.email}</p>}
                                    </div>

                                    {/* Programme Info */}
                                    {userData?.programme_category &&
                                        <div>
                                            <p className="lightColor text-sm pb-2">Programme</p>
                                            <p className="blackColor font-medium text-base">{userData?.programme_category}</p>
                                        </div>
                                    }
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            {/* PROD Issue */}
            {errorProfile &&
                <div className="cardBackgroundColor rounded-lg w-full justify-center p-4 mt-5">
                    <p className="text-base font-bold text-center blackColor">{errorProfile}</p>
                </div>
            }
            <div className={`space-y-4 md:space-y-0 md:grid md:grid-cols-4 md:gap-4 mt-4 mb-4 ${errorProfile ? "hidden" : "block"}`}>
                {userData?.competencies?.competency_status == true &&
                    <div className="">
                        <div className="cardBackgroundColor p-6 rounded-lg">
                            <div className="flex justify-between">
                                <h4 className="text-xl blackColor font-bold">{filteredData?.length !== 0 ? competencyGroup?.filter(group => group.competency_group_id === selectGroup)[0]?.name?.toUpperCase() : "Values"}</h4>
                                <div className='flex flex-wrap justify-between gap-2'>
                                    {filteredData?.length !== 0 && <>
                                        <div className='flex gap-3 cursor-pointer' onClick={() => { setSortOrder(sortOrder == "asc" ? "desc" : "asc") }}>
                                            {sortOrder == "asc" ?
                                                <>
                                                    <Tooltip title={"Click to sort by descending"} placement="top" arrow>
                                                        <span>
                                                            <BsSortUpAlt className='w-6 h-6 primaryIcon' />
                                                        </span>
                                                    </Tooltip>
                                                </> :
                                                <>
                                                    <Tooltip title={"Click to sort by ascending"} placement="top" arrow>
                                                        <span>
                                                            <BsSortDown className='w-6 h-6 primaryIcon' />
                                                        </span>
                                                    </Tooltip>
                                                </>
                                            }
                                        </div></>}
                                </div>
                            </div>
                            {compentencyLoading &&
                                <div className='w-full flex items-center justify-center h-full'>
                                    <CommonLoader />
                                </div>
                            }
                            {!compentencyLoading && filteredData?.length == 0 &&
                                <div className='w-full flex items-center justify-center h-full'>
                                    <div className='w-full flex items-center justify-center h-full'>
                                        <img src={noDataAvailableImg} alt="pics" className='overflow-hidden w-52' />
                                    </div>
                                </div>
                            }
                            {filteredData?.length !== 0 && <>
                                <ul className='pl-5 list-disc my-3 overflow-y-auto '>
                                    {filteredData?.map((item, index) => {
                                        // const count = item?.count || 0;
                                        // const percent = maxCount ? (count / maxCount) * 100 : 0;
                                        return (<>
                                            {item?.count !== 0 &&
                                                <li key={index} className="flex justify-between py-2 items-center gap-2">
                                                    <li className="lightColor text-sm">{item.value_title}</li>
                                                    <span className={`px-2 text-xs rounded-full h-5 w-5 flex items-center justify-center blueBackGroundColor text-white`}>{item?.count || 0}</span>
                                                </li>
                                            }</>
                                        );
                                    })}
                                </ul>
                            </>}
                            <div className={`flex gap-2 flex-wrap px-5 justify-center pt-2`}>
                                {filteredData?.length !== 0 && <>
                                    {competencyGroup?.map((i, index) => (<>
                                        {selectGroup == i.competency_group_id ?
                                            <ButtonCommonTopNew className="px-2 border p-1 text-xs rounded-lg cursor-pointer" onClick={() => { setSelectGroup(i.competency_group_id) }}>
                                                {i?.name?.toUpperCase()}
                                            </ButtonCommonTopNew> :
                                            <ButtonCommonTopGrey className="px-2 border p-1 text-xs rounded-lg cursor-pointer" onClick={() => { setSelectGroup(i.competency_group_id); setSortOrder("desc") }}>
                                                {i?.name?.toUpperCase()}
                                            </ButtonCommonTopGrey>
                                        }</>
                                    ))}
                                </>
                                }

                                <p className="text-sm lightColor w-full mt-auto text-center">{analyticsCardsDetails?.filter(x => x.card_name == "ca_values")[0]?.simple_description}​</p>
                            </div>
                        </div>
                    </div>
                }
                <div className={`${userData?.competencies?.competency_status == true ? "md:col-span-3" : "md:col-span-4"}  space-y-4 `}>
                    <div className="flex flex-1 flex-col relative space-y-4">
                        {
                            userData.teachingPhilosophy ?
                                <>
                                    <div className="relative rounded-lg myshowcaseCardHeight overflow-hidden cursor-pointer" onClick={() => history.push(`/public/${userId}/post/${teachingPhil.id}?profile_id=${profileId}`, { src: location.pathname + `?profile_id=${profileId}` })}>
                                        <div className="absolute inset-0 bg-cover myshowcaseCardHeight rounded-lg bg-no-repeat bg-center"
                                            style={{ backgroundImage: `url(${userData.pinnedImage ? userData.pinnedImage : bgImage})`, }}>
                                        </div>

                                        <p className="text-xl w-full text-center py-2 absolute font-bold text-black">{pinnedReflection ? pinnedReflection : "Teaching Philosophy"}</p>
                                        <div className="w-full blurText">
                                            <p className="text-base font-semibold w-full text-black">
                                                <RichTextReadMore
                                                    htmlContent={removeIframe(teachingPhil?.content)}
                                                    maxLines={4}
                                                    postId={teachingPhil?.id}
                                                    src={location.pathname + `?profile_id=${profileId}`}
                                                    isPublicProfileURL={`/public/${userId}/post/${teachingPhil.id}?profile_id=${profileId}`}
                                                />
                                            </p>
                                        </div>

                                        <div className="absolute bottom-2 right-0 flex float-right pr-6 justify-end items-center mt-3 lightColor text-sm">
                                            <LikeComment
                                                currentIsLiked={teachingPhil.is_like ? 1 : 0}
                                                numLikes={teachingPhil.likes}
                                                numComments={teachingPhil.comments}
                                                isShowcase={true}
                                                isPinned={false}
                                                reflection_id={teachingPhil.id}
                                                handleLike={(e) => { e.stopPropagation(); }}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </> : <>
                                </>
                        }

                        {
                            (userData.showcases && userData.showcases.length > 0) &&
                            <PublicShowcaseContainer
                                profile={userData}
                                data={userData.showcases}
                                likePost={handleLikePost}
                                addComment={handleAddComment}
                                profileTheme={theme}
                                isGuest={true}
                                guestCode={userId}
                                src={location.pathname + `?profile_id=${profileId}`}
                                isPublicProfileURL={(postId)=>{return `/public/${userId}/post/${postId}?profile_id=${profileId}`}}
                            />
                        }

                    </div>
                </div>
            </div>
        </PageWrapper>
    </>
    )
}

export default GuestPublicProfile

// import { React, useState, useEffect } from "react";
// import { useHistory, Link, useParams } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";

// import CardProfile from "../../components/Card/CardProfile";
// import Map from "../../components/Map";
// import CardStatus from "../../components/Card/CardStatus";
// import ValueComp from "../Footer/ValueComp";
// import hmenu_user from "../../common/images-new/no-profile-pic.png";
// import PageWrapper from '../PageWrapper';
// import ShowcaseContainer from './ShowcaseContainer';
// import ModalCreateShowcase from "../../components/Modal/ModalCreateShowcase";
// import ModalAddPost from "../../components/Modal/ModalAddPost";
// import Swal from "sweetalert2";

// import {
//     getShowcases,
//     createShowcase,
//     getAboutPost,
//     addShowcasePost,
//     getMyPosts,
//     getStatusPost
// } from "../../redux/actions/showcase";
// import PublicCardProfile from "../../components/Card/PublicCardProfile";
// import PublicShowcaseContainer from "./PublicShowcaseContainer";
// import { serverUrl } from "../../components/Helpers/Config";
// import axios from "axios";
// import { staticFiles } from "../../components/Helpers/Static";
// import PublicCardStatus from "../../components/Card/PublicCardStatus";
// import { tokenAuthorize } from "../../components/Helpers/Common";
// import { defaultTheme } from "../Theme";

// const SHOWCASE_ICON = staticFiles.book;
// const DEFAULT_COVER = staticFiles.coverDefault;
// const EDIT_LAYOUT_ICON = staticFiles.editLayout;

// function getQueryParam(key) {
//     const params = new URLSearchParams(window.location.search);
//     return params.get(key);
// }

// const GuestPublicProfile = () => {
//     const dispatch = useDispatch()

//     const { userId } = useParams()
//     const profileId = getQueryParam('profile_id');
//     const [userData, setUserData] = useState({
//         about: '',
//         competencies: [],
//         cover: '',
//         email: '',
//         name: '',
//         photo: '',
//         gid: '',
//         programme: '',
//         showcases: [],
//         guid: "",
//         pinnedImage: "",
//         programme_category: "",
//     })

//     const [teachingPhil, setTeachingPhil] = useState({
//         content: '',
//         id: 0,
//         likes: 0,
//         comments: 0,
//     })

//     const [theme, setTheme] = useState(null)

//     useEffect(() => {
//         loadUserData(userId)
//     }, [userId])
//     //PROD Issue
//     const [errorProfile, setErrorProfile] = useState('');
//     const loadUserData = (userCode) => {
//         localStorage.setItem('themeLoader', true);
//         return axios.get(
//             serverUrl.GuestShowcase + '/' + userCode + '?profile_id=' + profileId
//         ).then(resp => {
//             if (resp.status === 200) {
//                 const data = resp.data

//                 setUserData({
//                     about: data.about,
//                     gid: data.gid,
//                     competencies: data.competencies,
//                     cover: data.cover,
//                     email: (data.display_email && data.display_email.length > 0) ? data.display_email : data.email,
//                     name: data.fullname,
//                     photo: data.photo,
//                     programme: data.programme,
//                     showcases: data.showcases,
//                     teachingPhilosophy: data.teaching_philosophy,
//                     guid: data.guid,
//                     pinnedImage: data.pinned_reflection_image,
//                     programme_category: data.programme_category
//                 })
//                 if (data.teaching_philosophy) {
//                     setTeachingPhil({
//                         content: data.teaching_philosophy.content,
//                         id: data.teaching_philosophy.id,
//                         likes: data.teaching_philosophy.likes,
//                         is_like: data.teaching_philosophy.is_like,
//                         comments: data.teaching_philosophy.comments,
//                     })
//                 }
//                 if (data.theme) {
//                     let userTheme = data.theme;
//                     const currentTheme = {
//                         pageBackground: userTheme?.color1 ? userTheme?.color1 : '#F3F6F6',
//                         blue: userTheme?.color2 ? userTheme?.color2 : '#2084D4',
//                         darkBlue: userTheme?.color3 ? userTheme?.color3 : '#31658e',
//                         white: userTheme?.color4 ? userTheme?.color4 : 'white',
//                         black: userTheme?.color5 ? userTheme?.color5 : 'black',
//                         gray: userTheme?.color6 ? userTheme?.color6 : '#9ca3af',
//                         lightGray: userTheme?.color7 ? userTheme?.color7 : '#F9F9F9',
//                         green: userTheme?.color8 ? userTheme?.color8 : '#F9F9F9',
//                         navBg: userTheme?.color3 ? userTheme?.color3 : 'white',
//                         navText: userTheme?.color2 ? userTheme?.color2 : 'black',
//                         liDivColor: userTheme?.color1 ? userTheme?.color1 : 'black',
//                         liDivColorHover: userTheme?.color7 ? userTheme?.color7 : 'gray',
//                         buttonTopColor: 'white',
//                         modalInActiveBgColor: userTheme?.color4 ? userTheme?.color4 : 'white',
//                         modalInActiveColor: userTheme?.color6 ? userTheme?.color6 : 'Black',
//                         BorderColor: userTheme?.color6 ? userTheme?.color6 : 'gray',
//                         ButtonGreenBgColor: userTheme?.color4 ? userTheme?.color4 : '#66d693',
//                         ButtonGreenColor: userTheme?.color6 ? userTheme?.color6 : 'white',
//                         ButtonGreenHoverColor: userTheme?.color7 ? userTheme?.color7 : '#00b050',
//                         ButtonThemeGreen: userTheme?.color5 ? userTheme?.color5 : '#66d693',
//                         ButtonThemeBgGreen: userTheme?.color6 ? userTheme?.color6 : 'rgba(209, 213, 219)',
//                         PubishIcon: userTheme?.color8 ? userTheme?.color8 : 'black',
//                         sortIcon: userTheme?.color6 ? userTheme?.color6 : '#2084D4',
//                     }
//                     setTheme(currentTheme)
//                 } else {
//                     setTheme(defaultTheme)
//                 }
//                 localStorage.setItem('themeLoader', false);
//             } else {
//                 localStorage.setItem('themeLoader', false);
//             }
//         }).catch(err => {
//             localStorage.setItem('themeLoader', false);
//             tokenAuthorize(err?.response?.status);
//             console.log(err)
//             //PROD Issue
//             if (err?.response?.status == 500) {
//                 setErrorProfile("Invalid Learner Profile")
//             }

//         });
//     }

//     useEffect(() => {
//         let data = "userTheme" + userId;
//         localStorage.setItem(data, JSON.stringify(theme));
//     }, [theme])

//     const handleAddComment = (postId) => {

//         let updatedShowcases = userData.showcases.map(scData => ({
//             ...scData,
//             posts: scData.posts.map(scPost => ({
//                 ...scPost,
//                 comments: (scPost.id !== postId) ?
//                     scPost.comments :
//                     scPost.comments + 1,
//             }))
//         }))

//         setUserData({
//             ...userData,
//             showcases: updatedShowcases
//         })

//         if (teachingPhil.id === postId) {
//             setTeachingPhil({
//                 ...teachingPhil,
//                 comments: teachingPhil.comments + 1
//             })
//         }
//     }

//     const handleLikePost = (postId, isLiked) => {
//         const likeDiff = isLiked ? 1 : -1;

//         let updatedShowcases = userData.showcases.map(scData => ({
//             ...scData,
//             posts: scData.posts.map(scPost => ({
//                 ...scPost,
//                 likes: (scPost.id !== postId) ? scPost.likes : {
//                     avatars: scPost.likes.avatars,
//                     is_like: likeDiff > 0 ? true : false,
//                     count: scPost.likes.count + likeDiff
//                 }
//             }))
//         }))

//         setUserData({
//             ...userData,
//             showcases: updatedShowcases
//         })

//         if (teachingPhil.id === postId) {
//             setTeachingPhil({
//                 ...teachingPhil,
//                 is_like: likeDiff > 0 ? true : false,
//                 likes: teachingPhil.likes + likeDiff
//             })
//         }
//     }

//     return (
//         <PageWrapper hideNav={true} isGuest={true} tempTheme={theme}>
//             <div className="h-40 md:h-56 lg:h-68 xl:h-72 w-full object-contain overflow-hidden">
//                 <img
//                     className="w-full h-auto"
//                     style={{ backgroundColor: '#ECECEC' }}
//                     src={(userData.cover && (userData.cover.length > 0)) ? userData.cover : DEFAULT_COVER}
//                     alt="Cover" />
//             </div>

//             <div className="flex flex-col md:flex-row">
//                 <div className="flex flex-col items-center mx-5 md:ml-5 xl:ml-24 xl:mr-9">
//                     <PublicCardProfile
//                         profilePic={userData.photo}
//                         username={userData.name}
//                         email={userData.email}
//                         programCategory={userData?.programme_category}
//                         program={userData.programme}
//                         aboutMe={userData.about}
//                         userId={userId}
//                         isGuest={true}
//                     // reflectionId={aboutPost[0]? aboutPost[0].reflection_id : ''}
//                     />

//                     {/* <div className="hidden md:block flex flex-col md:mt-40 lg:mt-5 mb-16 ">
//                         <Map />
//                     </div> */}
//                 </div>

//                 <div className="flex flex-1 flex-col mx-2 md:mx-5 ml-0 xl:mr-24 relative">
//                     {/* PROD Issue */}
//                     {errorProfile && <p className="mt-4 text-center pt-10">{errorProfile}</p>}
//                     {
//                         userData.teachingPhilosophy ?

//                             <PublicCardStatus
//                                 post={teachingPhil}
//                                 userId={userId}
//                                 likePost={handleLikePost}
//                                 isGuest={true}
//                                 pinnedImage={userData.pinnedImage}
//                                 guid={userData?.guid}
//                             // statusPost={statusPost[0]}
//                             />
//                             :
//                             <div className="mb-10 md:mb-0 lg:mb-10" />
//                     }

//                     {
//                         (userData.showcases && userData.showcases.length > 0) &&
//                         <PublicShowcaseContainer
//                             profile={userData}
//                             data={userData.showcases}
//                             likePost={handleLikePost}
//                             addComment={handleAddComment}
//                             isGuest={true}
//                             guestCode={userId}
//                         />

//                     }

//                 </div>


//             </div>

//             {/* {userData?.competencies?.competency_status == true &&
//                 <ValueComp
//                     data={userData?.competencies?.values}
//                     isValue={true}
//                 />} */}

//             {/* <div className="block md:hidden flex flex-col items-center bg-white pb-5">
//                 <Map />
//             </div> */}
//         </PageWrapper>
//     )
// }

// export default GuestPublicProfile